<section class="dictionary-section section-pd bg-light-purple card-carousel">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center mb-0">
                    <h2>內建專業領域字典</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div id="dictionaries-carousel" class="carousel slide" data-ride="carousel">
            <div class="row align-items-center justify-content-center">
                <div class="col-lg-6 col-md-6">
                    <div class="carousel-indicators position-relative">
                        <button  type="button" data-target="#dictionaries-carousel" data-slide-to="0"class="active">
                            <span>醫學</span>
                        </button>
                        <button  type="button" data-target="#dictionaries-carousel" data-slide-to="1">
                            <span>生命科學</span>
                        </button>
                        <button  type="button" data-target="#dictionaries-carousel" data-slide-to="2">
                            <span>物理</span>
                        </button>
                        <button  type="button" data-target="#dictionaries-carousel" data-slide-to="3">
                            <span>社會科學</span>
                        </button>
                        <button  type="button" data-target="#dictionaries-carousel" data-slide-to="4">
                            <span>工程學 </span>
                        </button>
                        <button  type="button" data-target="#dictionaries-carousel" data-slide-to="5">
                            <span>化學</span>
                        </button>
                        <button  type="button" data-target="#dictionaries-carousel" data-slide-to="6">
                            <span>地質學</span>
                        </button>
                        <button  type="button" data-target="#dictionaries-carousel" data-slide-to="7">
                            <span>資訊科學</span>
                        </button>
                        <button  type="button" data-target="#dictionaries-carousel" data-slide-to="8">
                            <span>經濟學</span>
                        </button>
                        <span class="trinka-line hr-line left-33"></span>
                        <span class="trinka-line hr-line left-66"></span>
                        <span class="trinka-line vr-line top-33"></span>
                        <span class="trinka-line vr-line top-66"></span>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="ct-card position-relative">
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <div class="carousel-card">
                                    <h4>醫學</h4>  
                                    <p>The physician recommended a throrough examination of the <span class="wrongText">gastrointestial</span> <span class="rightText">gastrointestinal</span> tract.</p>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card">
                                    <h4>生命科學</h4>
                                    <p>The most abundant <span class="wrongText">phylla</span> <span class="rightText">phyla</span> were <span class="wrongText d-inline">Pseudomonodota</span> <span class="rightText d-inline">Pseudomonadota</span> (22%) and <span class="wrongText d-inline">Bacterodota</span> <span class="rightText d-inline">Bacteroidota</span> (18%).
                                    </p>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card">
                                    <h4>物理</h4>
                                    <p>Stength of IMF-sensitive stellar <span class="wrongText d-inline">absorbtion</span> <span class="rightText d-inline">absorption</span> features is regulated by the ratio of dwarf to giant stars.</p>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card">
                                    <h4>社會科學s</h4>
                                    <p>The elements of protest masculinity discount the <span class="wrongText d-inline">embodimint</span> <span class="rightText d-inline">embodiment</span> of pure inclusive masculinity.
                                    </p>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card">
                                    <h4>工程學 </h4>
                                    <p>We presented a novel approach to derive <span class="wrongText d-inline">nonliner</span> <span class="rightText d-inline">nonlinear</span> filters from schematics of audio  <span class="d-inline">circits</span> <span class="themeColor d-inline">circuits</span>.
                                    </p>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card">
                                    <h4>化學</h4>
                                    <p>Adjunct therapy with <span class="wrongText d-inline">hyaluranic</span> <span class="rightText d-inline">hyaluronic</span> acid provides a long lasting therapeutic effect.
                                    </p>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card">
                                    <h4>地質學</h4>
                                    <p>The low contents of incompatible elements indicate negligible involvement of <span class="wrongText d-inline">terrigeneous</span> <span class="rightText d-inline">terrigenous</span> clastics during the deposition.</p>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card">
                                    <h4>資訊科學</h4>
                                    <p>A new deep <span class="wrongText d-inline">regulization</span> <span class="rightText d-inline">regularization</span> mechanism allows the learning model to unlearn biased information.</p>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card">
                                    <h4>經濟學</h4>
                                    <p>Use of monetary <span class="wrongText d-inline">agregates</span> <span class="rightText d-inline">aggregates</span> as indicators of policy is controversial because of many factors.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- Left and right controls/icons -->
                        <button class="carousel-control-prev" type="button" data-target="#dictionaries-carousel" data-slide="prev" aria-label="Previous Slide">
                            <span class="carousel-control-prev-icon"></span>
                        </button>
                        <button class="carousel-control-next" type="button" data-target="#dictionaries-carousel" data-slide="next" aria-label="Next Slide">
                            <span class="carousel-control-next-icon"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>